<script>
  import { IndexScreen } from '../module_core/module_index'
  import IndexLayout from '../module_layout/index/index-layout.svelte'
</script>

<svelte:head>
  <title>Lutruvials - Criação Software e Sites sob Medida para sua Empresa</title>

  <!-- Primary Meta Tags -->
  <meta
    name="description"
    content={'Criamos sistemas, sites, e-commerce e automações sob medida. Cada projeto é único e pensado para a sua operação. Fale com a gente.'}
  />

  <!-- Open Graph / Facebook -->
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://lutruvials.com" />
  <meta
    property="og:title"
    content="Lutruvials - Criação Software e Sites sob Medida para sua Empresa"
  />
  <meta property="og:site_name" content="Lutruvials" />
  <!-- prettier-ignore -->
  <meta property="og:description" content={'"Já deu, não queremos mais soluções prontas, Queremos algo único e sob-medida.", Criamos sistemas, sites, e-commerce e automações sob medida. Cada projeto é único e pensado para a sua operação. Fale com a gente.'} />
  <meta property="og:image" content="https://lutruvials.com/jpeg/og-banner.jpg" />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />
  <meta property="og:image:alt" content="Criamos software/sistemas, sites, e-commerce" />
  <meta property="og:image:type" content="image/jpeg" />
  <!-- X (Twitter) -->
  <meta property="twitter:card" content="summary_large_image" />
  <meta property="twitter:url" content="https://lutruvials.com" />
  <meta
    property="twitter:title"
    content="Lutruvials - Criação Software e Sites sob Medida para sua Empresa"
  />
  <meta
    property="twitter:description"
    content={'"Já deu, não queremos mais soluções prontas, Queremos algo único e sob-medida.", Criamos sistemas, sites, e-commerce e automações sob medida. Cada projeto é único e pensado para a sua operação. Fale com a gente.'}
  />
  <meta property="twitter:image" content="https://lutruvials.com/jpeg/og-banner.jpg" />

  <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "ProfessionalService",
          "@id": "https://lutruvials.com/#organization",
          "name": "Lutruvials",
          "alternateName": ["Lutruvials", "Vitruvius", "Tutorial"],
          "url": "https://lutruvials.com/",
          "logo": "https://www.datocms-assets.com/146396/1731702742-logo-extend.png",
          "image": "https://www.datocms-assets.com/146396/1731702742-logo-extend.png",
          "description": "A Lutruvials cria soluções de tecnologia sob medida para empresas. Somos especializados em desenvolvimento de sistemas, sites de alta conversão, e-commerce e automação de processos. Chega de pagar pelo que você não usa — aqui cada projeto é único e pensado para a sua operação.",
          "taxID": "58.642.077/0001-45",
          "telephone": "+55-11-99310-8947",
          "priceRange": "$$",
          "slogan": "Software sob medida para a sua empresa crescer sem dor de cabeça.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Parque Macedo",
            "addressLocality": "São Paulo",
            "addressRegion": "SP",
            "postalCode": "08595-360",
            "addressCountry": "BR"
          },
          "knowsAbout": [
            "Desenvolvimento de software sob medida",
            "Fábrica de software",
            "Software personalizado empresarial",
            "Sistemas de gestão ERP",
            "Aplicativos mobile corporativos",
            "Automação de processos",
            "Integração de sistemas",
            "Desenvolvimento de sistemas web",
            "CRM personalizado",
            "Criação de Sites",
            "Criação de E-commerce"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+55-11-99310-8947",
            "contactType": "customer service",
            "areaServed": "BR",
            "availableLanguage": ["Portuguese", "English"]
          },
          "sameAs": [
            "https://www.linkedin.com/company/lutruvials",
            "https://www.instagram.com/lutruvials"
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Serviços Lutruvials",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Desenvolvimento de sistemas sob medida",
                  "description": "Criar sistemas internos para tomadas de decisão, painéis administrativos de alta performance com automações, implementações de regras complexas e fluxos de trabalhos complexos para operações do seu negócio.",
                  "serviceType": "Software Development",
                  "areaServed": {
                    "@type": "Country",
                    "name": "Brazil"
                  }
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Criação de sites com foco em conversão",
                  "description": "Com a Lutruvials o preço de um site institucional é acessível e competitivo com seus concorrentes, nosso objetivo claro é gerar vendas e não apenas deixar o site 'existir', com otimização e manutenção mensal.",
                  "serviceType": "Web Development",
                  "areaServed": {
                    "@type": "Country",
                    "name": "Brazil"
                  }
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Desenvolvimento de E-commerce",
                  "description": "Abrir a sua loja virtual bem estrutura é complicado, com a Lutruvials a gente foca em uma estrutura robusta, performance e integrações pensando em escalabilidade na necessidade que seu negócio precisa no momento.",
                  "serviceType": "E-commerce Development",
                  "areaServed": {
                    "@type": "Country",
                    "name": "Brazil"
                  }
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Integrações e Automação de processos",
                  "description": "Deixamos seu CRM, ERP integrado com gateways de pagamentos, software de planejamento e processos com automação de fluxos de trabalhos manuais, e seguros.",
                  "serviceType": "System Integration",
                  "areaServed": {
                    "@type": "Country",
                    "name": "Brazil"
                  }
                }
              }
            ]
          }
        },
        {
          "@type": "WebSite",
          "@id": "https://lutruvials.com/#website",
          "url": "https://lutruvials.com/",
          "name": "Lutruvials",
          "description": "Soluções de tecnologia sob medida — sistemas, sites, e-commerce e automação para empresas.",
          "publisher": {
            "@id": "https://lutruvials.com/#organization"
          },
          "inLanguage": "pt-BR",
          "keywords": [
            "software sob medida estoque",
            "desenvolvimento de sob medida",
            "software corporativo para empresas em são paulo",
            "orçamento sem compromisso",
            "software que ajuda empresa a crescer",
            "integração simplificada",
            "software para gestão de estoque",
            "criação de loja virtual",
            "criação de sites com foco em conversão"
          ]
        }
      ]
    }
  </script>
</svelte:head>

<IndexLayout headerIsActive={false}>
  <main>
    <IndexScreen />
  </main>
</IndexLayout>
